module.exports = __webpack_public_path__ + "img/s00135.f7e3ae72.jpg";